// extracted by mini-css-extract-plugin
export default {"formColumn":"style_formColumn__7U0Vq"};